import { Breadcrumb, Button, Card, Col, Drawer, Flex, Form, Input, Layout, message, Popconfirm, Row, Select, Steps, Table, Tag, theme } from 'antd';
import { FilterOutlined, HomeOutlined, DeleteOutlined, EyeOutlined, EditOutlined, FileWordOutlined } from '@ant-design/icons';
import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import RequestApproval from '../../../restAPI/RequestApproval';
import { useSelector } from 'react-redux';

const { Search, TextArea } = Input;
const { Option } = Select;

const GeneralInfo = forwardRef(({ setData, savedData }, ref) => {
    const { companyId, token, userCompany, role } = useSelector(state => state.auth);
    const [formdata, setFormdata] = useState({
        // branch:"",
        requesttype: "",
        subjectline: "",
        // message:""

    });
    const [requestTypes, setRequestTypes] = useState([])
    const [branches, setBranches] = useState([])
    const [form] = Form.useForm();
    const handleFormChange = (changedValues, allValues) => {
        setFormdata(allValues); // Update state with all form values
    };
    const handleSubmit = () => {
        // console.log("Submitted Data:", formdata);
    };

    RequestApproval.testWithJWTandCID(companyId, token);
    useEffect(() => {
        getInitialData();
        setFormdata(savedData);
    }, [])

    useEffect(() => {
        // console.log(formdata, "formdata")
    }, [formdata])

    useImperativeHandle(ref, () => ({
        async saveGenaralData() {
            try {
                await form.validateFields();
                setData(formdata);
                return { status: true, res: formdata }
            } catch (errorInfo) {
                console.error('Validation Failed:', errorInfo);
                return { status: false, res: null }
            }

        }
    }));

    const getInitialData = async () => {
        await RequestApproval.getRequestTypes().then((data) => {
            setRequestTypes(data.data);
            // console.log(data, "request types");
        });
        await RequestApproval.getBranches().then((data) => {
            setBranches(data.data);
            // console.log(data, "branches");
        });


    }

    return (
        <>
            <Card
                bordered={false}
                title="General Information"
            // extra={<a href="#">More</a>}
            >
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={savedData}
                    onValuesChange={handleFormChange}
                    onFinish={handleSubmit}
                >
                    <Row gutter={24}>
                        <Col lg={8} md={8} sm={24} >
                            <Form.Item name="branch" label="Branch" >
                                <Select
                                    placeholder="Select Branch"
                                    allowClear
                                >
                                    {branches.map((branch, index) => (
                                        <Option key={index} value={branch._id}>{branch.name}</Option>
                                    ))

                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col lg={8} md={8} sm={24} >
                            <Form.Item name="requesttype" label="Request Type" rules={[{ required: true, message: 'Please select request type!' }]}>
                                <Select
                                    placeholder="Select Request Type"
                                    allowClear
                                >
                                    {requestTypes.map((request, index) => (
                                        <Option key={index} value={request._id}>{request.requestType}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col lg={8} md={8} sm={24} >
                            <Form.Item name="subjectline" label="Subject Line" rules={[{ required: true, message: 'Please add subject line!' }]}>
                                <Input placeholder="Enter Subject Line" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col lg={24} md={24} sm={24} >
                            <Form.Item name="message" label="Message" >
                                <TextArea rows={4} maxLength={300} showCount  />
                            </Form.Item>
                        </Col>
                    </Row>

                </Form>
            </Card>
        </>
    )
});

export default GeneralInfo
